import { useEffect, useRef } from "react";

import { ChipRadioGroup } from "../../../../core/Chip.js";
import type { BoxCategoriesContent } from "../../boxesContent.js";

/**
 * The store's box categories as one row of chips over the grid, every box first. The row never
 * wraps: past the page's width it scrolls sideways, and the chip showing is scrolled into view.
 */
export function BoxesCategories({ value, label, options, onValueChange }: BoxCategoriesContent) {
  const stripRef = useRef<HTMLDivElement>(null);
  const showing = options.findIndex((option) => option.value === value);

  // Sideways only, so a category picked from a link never scrolls the page itself.
  useEffect(() => {
    const strip = stripRef.current;
    const chip = strip?.querySelectorAll<HTMLElement>('[role="radio"]')[showing];
    if (!strip || !chip || strip.scrollWidth <= strip.clientWidth) return;
    const bounds = strip.getBoundingClientRect();
    const box = chip.getBoundingClientRect();
    if (box.left < bounds.left || box.right > bounds.right) {
      strip.scrollLeft += box.left - bounds.left - (bounds.width - box.width) / 2;
    }
  }, [showing]);

  return (
    <div ref={stripRef} className="-mx-4 overflow-x-auto px-4 pb-1 sm:mx-0 sm:px-0">
      <ChipRadioGroup
        label={label}
        value={value}
        options={options}
        onValueChange={onValueChange}
        className="w-max flex-nowrap"
      />
    </div>
  );
}
